import { useEffect, useRef, useState, ReactNode } from 'react';
import styles from './ExpandableCaption.module.css';

type Props = {
  children: ReactNode;
  initExpanded?: boolean;
};

const ExpandableCaption = ({ children, initExpanded = false }: Props) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const [isExpandable, setExpandable] = useState<boolean>(false);
  const [isExpanded, setExpanded] = useState<boolean>(initExpanded);

  function countLines() {
    if (!ref.current) return 0;
    ref.current.style.display = 'inline';
    const rects = ref.current.getClientRects();
    return rects?.length ?? 0;
  }

  useEffect(() => {
    const count = countLines();
    count > 3 && setExpandable(true);
  }, []);

  useEffect(() => {
    if (!ref.current || !isExpandable) return;
    ref.current.style.display = '-webkit-box';
  }, [isExpandable]);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.webkitLineClamp = isExpanded ? 'inherit' : '3';
  }, [isExpanded]);

  return (
    <div className={styles.Container}>
      <p ref={ref}>{children}</p>
      {isExpandable && (
        <button onClick={() => setExpanded(!isExpanded)}>
          Show {isExpanded ? 'less' : 'more'}
        </button>
      )}
    </div>
  );
};

export default ExpandableCaption;
